import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A roadtrip: fin",
  "description": "",
  "published": "2012-08-06T00:00:00.000Z",
  "redirect_from": ["/blog/a-roadtrip-fin/swizec/4972"],
  "categories": "Adriatic Sea, City Wall, Dubrovnik, Former Yugoslavia, Game of Thrones, Mostar, Red Bull, Roadtrip, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/08/dubrovnik-panorama2mini.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/08/dubrovnik-panorama2mini.jpg",
          "alt": "Dubrovnik city walls",
          "title": "Dubrovnik city walls"
        }}></img></a></p>
    <p>{`At 9am on Friday, after being awake for twenty-four hours, `}<a parentName="p" {...{
        "href": "http://twitter.com/ponywithhiccups"
      }}>{`@ponywithhiccups`}</a>{` and I concluded The Roadtrip by collapsing into bed. This morning (Monday) is the first time I woke up actually feeling rested.`}</p>
    <p>{`You know it's been an epic adventure when the hangover lasts for four days! And even though we had to cut it short by a few days because ... money stuff ... it was bloody brilliant!`}</p>
    <p>{`Looking forward to doing something similar again. Soon. But not the drive home ... that was a silly and tiring part. Five cans of Red Bull and one cup of tea and one thirty minute nap tiring.`}</p>
    <p>{`But let's start at the beginning, the `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-roadtrip-second-leg/swizec/4953",
        "title": "A roadtrip: second leg"
      }}>{`last roadtrip blogpost`}</a>{` concluded with us arriving in `}<a parentName="p" {...{
        "href": "http://whc.unesco.org/en/list/95",
        "title": "Old City of Dubrovnik"
      }}>{`Dubrovnik`}</a>{` and setting up a large tent on rocky ground at night.`}</p>
    <p>{`PS: this post turned out a bit long, scroll through at least for the pictures ;)`}</p>
    <h2 {...{
      "id": "dubrovnik"
    }}>{`Dubrovnik`}</h2>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/08/IMG_1932.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1932-1024x768.jpg",
          "alt": "Dubrovnik",
          "title": "Dubrovnik"
        }}></img></a></p>
    <p>{`Dubrovnik - the city that played `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/World_of_A_Song_of_Ice_and_Fire",
        "title": "World of A Song of Ice and Fire"
      }}>{`King's Landing`}</a>{` in `}<a parentName="p" {...{
        "href": "http://www.hbo.com/game-of-thrones",
        "title": "Game of Thrones"
      }}>{`Game of Thrones`}</a>{` last season - is probably the most gorgeous city I've ever visited as a tourist.`}</p>
    <p>{`The City Wall is just as impressive and mesmerizing as I remember it from the roadtrip with my dad ~12 years ago, but then I've always been a sucker for medieval buildings. Going the whole way around would take too long, but we did get to see a bunch of very pretty views, some old canons, a few jail cells and plenty of the unrelenting sun.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1947-768x1024.jpg",
        "alt": "Swizec in jail",
        "title": "Swizec in jail"
      }}></img></p>
    <p>{`My favourite were the jail cells - great acoustics in there and a nice sea breeze. Although being locked up in there, three to four storeys above the sea must have been ... quite an experience.`}</p>
    <p>{`Not even enough room to lie down. Ouch.`}</p>
    <p>{`Besides the City Wall, Dubrovnik looks a lot like any wealthy old town - everything is white and shiny, no hint of vegetation anywhere, all the streets are cramped and all the buildings are very tall. I heard a couple discussing that it's much prettier/better than `}<a parentName="p" {...{
        "href": "http://whc.unesco.org/en/list/394",
        "title": "Venice and its Lagoon"
      }}>{`Venice`}</a>{`.`}</p>
    <p>{`One great thing about Dubrovnik is that it's actually a very clean and orderly city. There's barely a hint of rundown buildings (common in most of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Former_Yugoslavia",
        "title": "Former Yugoslavia"
      }}>{`ex-Yugoslavia`}</a>{`) and the only ruins you see are actual ruins rather than houses abandoned for the past 20 or 30 years.`}</p>
    <p>{`The absolute worst, however, is the price of everything. They even have a tax on laziness! Parking ~500 meters from the wall costs about 0.66 euro, parking right next to the walls is just under 4 euro. In the blazing sun.`}</p>
    <p>{`And I'm sorry but charging 6 euro for an audio guide on top of a 10 euro entrance fee to The Wall is pretty terrible. Not that the entrance fee is too expensive, but charge me 12 euro and give me the guide for free.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo-11-e1344249171498-1024x764.jpg",
        "alt": "Troubadours",
        "title": "Troubadours"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo-21-e1344249234790-764x1024.jpg",
        "alt": "Wall cliff thing",
        "title": "Wall cliff thing"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1954-768x1024.jpg",
        "alt": "You can totally climb up a church",
        "title": "You can totally climb up a church"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1978-1024x768.jpg",
        "alt": "Want a romantic dinner? Dubrovnik is your man",
        "title": "Want a romantic dinner? Dubrovnik is your man"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_2003-1024x768.jpg",
        "alt": "This cat needs a redditor",
        "title": "This cat needs a redditor"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo2-e1344249415170-764x1024.jpg",
        "alt": "Sunset on the main street",
        "title": "Sunset on the main street"
      }}></img></p>
    <h2 {...{
      "id": ""
    }}></h2>
    <h2 {...{
      "id": "mostar"
    }}>{`Mostar`}</h2>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage8.instagram.com/1ecf8b18dd2111e19d0322000a1d02f2_7.jpg",
        "alt": "Čevapi in Mostar",
        "title": "Čevapi in Mostar"
      }}></img></p>
    <p>{`Conversely Mostar was a surprisingly cheap experience. Eating famous local cuisine (čevapi) right next to their most popular tourist destination was cheaper than a meal in Ljubljana.`}</p>
    <p>{`Everyone knows you don't visit Bosnia without eating čevapi.`}</p>
    <p>{`I'd say they were delicious and a whole lot different and better and more realer than what I'm used to eating at home, but I inhaled them so quickly I don't even remember the taste beyond `}<em parentName="p">{`"It was very tasty."`}</em></p>
    <p>{`The old town itself has a much poorer feel to it than Dubrovnik did. The streets weren't made of marble, there was no hint of white anywhere and most of the buildings looked to be made of plain rocks. Actually the streets looked like river stones thrown into some cement.`}</p>
    <p>{`Even though the Old Bridge is a reconstruction of the 16th century ottoman bridge and has only been open for 8 years now, it still looks pretty good. Most of the road-surface looks very authentic. It's a real shame it was blown up after standing for some 470 years. Strategic value my arse.`}</p>
    <p>{`I mean, the bridge is about two meters wide and the road-surface is more a ladder than it is a road. Yep, at foot-length intervals there's a 5cm wide stone step that protrudes about 5cm from the actual surface. Makes it very easy to walk up and down the incredibly slick stone.`}</p>
    <p>{`Oh and people dive from the bridge. Crazy bastards. With a loud crash one of them even surprised us right when we were nomming on the čevapi.`}</p>
    <p>{`To my great disappointment, we completely forgot to go look for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mostar_Bruce_Lee_statue"
      }}>{`Bruce Lee's statue`}</a>{`. Although according to Wikipedia it's been removed anyway ... weird.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo1-1024x764.jpg",
        "alt": "Old Town Mostar",
        "title": "Old Town Mostar"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo-1-1024x764.jpg",
        "alt": "A clearer view of the bridge",
        "title": "A clearer view of the bridge"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo-2-1024x764.jpg",
        "alt": "View from the bridge",
        "title": "View from the bridge"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_2050-1024x768.jpg",
        "alt": "Mostar is full of rockets",
        "title": "Mostar is full of rockets"
      }}></img></p>
    <h2 {...{
      "id": "-1"
    }}></h2>
    <h2 {...{
      "id": "looooong-drive-home"
    }}>{`Looooong drive home`}</h2>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/08/202505_10150999892841267_1541795793_o.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/08/202505_10150999892841267_1541795793_o-1024x256.jpg",
          "alt": "A pit stop",
          "title": "A pit stop"
        }}></img></a></p>
    <p>{`We had originally planned to go home from Dubrovnik in two trips. Go to Mostar and then Pag, sleep over for a night or two and then head back home to Ljubljana.`}</p>
    <p>{`Pag never happened, not because we'd run out of money per se, but because there wouldn't be enough buffer left for emergencies. And you don't want to be trapped in a foreign country - even Croatia - without any buffer money.`}</p>
    <p>{`After a three hour drive we arrived at Mostar just in time to avoid a heat stroke or two. By now all of our water was warm enough to shower with and we were drenched in ... ourselves. But that's what you get for traveling at high afternoon on sunny roads without air conditioning when it's anywhere between 34 and 36 degrees in the shade.`}</p>
    <p>{`Just leave sooner right? We did (at 8am). Packing up the tent, making sure both phones are charged, having breakfast and writing all the postcards makes 1pm arrive mighty quick.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1650-1024x768.jpg",
        "alt": "A church near Mostar",
        "title": "A church near Mostar"
      }}></img></p>
    <p>{`After Mostar the weather cooled down a bit and we were okay to drive for the seven more hours it would take us to get home by the scenic seaside route (`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Adriatic_Highway"
      }}>{`Jadranska Magistrala`}</a>{`).`}</p>
    <p>{`The vagabond shower in Šibenik was easily my favourite part of the whole roadtrip. Jumping into the sea after ~7 hours in the car and 3 hours in Mostar was amazing in itself, but doing it on a beach with that amazing a view? Priceless.`}</p>
    <p>{`Can't even describe how good it felt to be clean again.`}</p>
    <p>{`After that the ride back to Ljubljana was pretty uneventful. At one point I was forced to take a short road-side nap because I almost couldn't see the road anymore my eyes were so tiny. Even almost kind of started swerving a bit. Not enough for @ponywithhiccups to notice, but definitely enough to know the car wasn't always doing exactly what I wanted it to.`}</p>
    <p>{`If you ever get the chance to drive along a curvy empty road at night (alone, or the only one awake) - go for it. It's one of the most meditative and calming experiences I have ever had. No wonder `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hunter_Thompson"
      }}>{`Thompson`}</a>{` used to race around the mountains on his bike when he had to think.`}</p>
    <p>{`But I wouldn't recommend driving for ten hours while being awake for twenty-four after a five-ish hour night. It's just as safe as it sounds and it's taken me almost two days to recover enough to write about. To even think about.`}</p>
    <p>{`But I have to say, this roadtrip will stay in memory longer than most things do.`}</p>
    <p>{`And for all the right reasons.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_2028-1024x768.jpg",
        "alt": "Heading out of Dubrovnik",
        "title": "Heading out of Dubrovnik"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/photo-e1344104367841-1024x764.jpg",
        "alt": "View of Šibenik from the beach",
        "title": "View of Šibenik from the beach"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1652-1024x768.jpg",
        "alt": "A road",
        "title": "A road"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1813-1024x768.jpg",
        "alt": "Landscape so pretty it looks rendered",
        "title": "Landscape so pretty it looks rendered"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1821-1024x768.jpg",
        "alt": "Looking closely enough reveals a village on that hill",
        "title": "Looking closely enough reveals a village on that hill"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/08/IMG_1854-1024x768.jpg",
        "alt": "This is interesting, but I don't know why",
        "title": "This is interesting, but I don't know why"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-second-leg/swizec/4953"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103729212_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-second-leg/swizec/4953"
        }}>{`A roadtrip: second leg`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-wherein-swizec-is-not-to-be-trusted-with-important-objects-without-supervision/swizec/4923"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103324153_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-wherein-swizec-is-not-to-be-trusted-with-important-objects-without-supervision/swizec/4923"
        }}>{`A roadtrip: wherein Swizec is not to be trusted with important objects without supervision`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-first-leg/swizec/4906"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103068899_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/a-roadtrip-first-leg/swizec/4906"
        }}>{`A roadtrip: First leg`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://sebasilver.wordpress.com/2012/06/13/so-many-reasons-to-love-dubrovnik/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/94176601_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://sebasilver.wordpress.com/2012/06/13/so-many-reasons-to-love-dubrovnik/"
        }}>{`So many reasons to love Dubrovnik`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://photoblog.nbcnews.com/_news/2012/07/30/13026636-competitors-take-plunge-off-bridge-in-mostar"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/103666117_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://photoblog.nbcnews.com/_news/2012/07/30/13026636-competitors-take-plunge-off-bridge-in-mostar"
        }}>{`Competitors take plunge off bridge in Mostar`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=a3a58b52-b1f1-44ac-b00b-9f84c325519a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      